import { type RefObject, useRef, useState } from "react";

interface UseIsTruncatedReturn<T extends HTMLElement = HTMLElement> {
  textRef: RefObject<T>;
  isTruncated: boolean;
  checkTruncation: () => void;
}

export const useIsTruncated = <
  T extends HTMLElement = HTMLElement,
>(): UseIsTruncatedReturn<T> => {
  const textRef = useRef<T>(null) as RefObject<T>;
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = () => {
    const elem = textRef.current;
    if (elem) {
      const isOverflowingX = elem.scrollWidth > elem.clientWidth;
      const isOverflowingY = elem.scrollHeight > elem.clientHeight;

      setIsTruncated(isOverflowingX || isOverflowingY);
    }
  };

  return {
    textRef,
    isTruncated,
    checkTruncation,
  };
};
